export enum ButtonStyle {
    Primary = 'primary',
    Secondary = 'secondary',
    SecondAccordionLevel = 'second-accordion-level',
}
